const seenKeys: Record<string, boolean> = {};

const MULTIPLIER = Math.pow(2, 24);

export function generateRandomKey(): string {
  let key;
  // eslint-disable-next-line no-prototype-builtins
  while (key === undefined || seenKeys.hasOwnProperty(key) || !isNaN(+key)) {
    key = Math.floor(Math.random() * MULTIPLIER).toString(32);
  }
  seenKeys[key] = true;
  return key;
}
